import { formatTimestamp, getDataDomainByQuery } from '@services/data'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import NetworkLineChart, { ChartProps } from './NetworkLineChart'
import { EuiFlexGroup, EuiFlexItem, EuiTitle } from '@elastic/eui'
import _ from 'lodash'

type FilemakerChartProps = ChartProps

const FilemakerChart = (props: FilemakerChartProps) => {
    const { t } = useTranslation(['network'])
    const xAxisDomain = useMemo(
        () => getDataDomainByQuery(props.query),
        [props.query]
    )

    const databases = useMemo(() => {
        const snapshot = _.findLast(
            props.data as any[],
            (d) => d.filemakerDatabasesCount
        )

        if (!snapshot) return []

        return [...Array(Number(snapshot.filemakerDatabasesCount))].map(
            (_, i) => ({
                filename: snapshot[`filemakerDatabaseFilename_${i}`],
                id: snapshot[`filemakerDatabaseId_${i}`],
                status: snapshot[`filemakerDatabaseStatus_${i}`],
                size: snapshot[`filemakerDatabaseSize_${i}`],
            })
        )
    }, [props.data])

    return (
        <EuiFlexGroup direction="column">
            <EuiFlexItem>
                <EuiTitle size="xs">
                    <h4>{t('network:filemaker_server_status')}</h4>
                </EuiTitle>
                <NetworkLineChart
                    height={250}
                    legendWidth={175}
                    yAxisWidth={100}
                    data={props.data}
                    query={props.query}
                    setQuery={props.setQuery}
                    lines={[
                        {
                            key: 'filemakerServerStatus',
                            label: t(
                                'network:data_key_filemaker_server_status'
                            ),
                        },
                    ]}
                    xAxis="timestamp"
                    xAxisFormatter={(v) => formatTimestamp(v, props.query)}
                    xAxisDomain={xAxisDomain}
                    yAxisType="category"
                    yAxisDomain={['STOPPED', 'RUNNING']}
                    yAxisFormatter={(v) => {
                        return t(`network:data_value_${v}`)
                    }}
                />
            </EuiFlexItem>

            {databases.map((db, index) => (
                <EuiFlexItem key={db.filename}>
                    <EuiTitle size="xs">
                        <h4>
                            {t('network:filemaker_db_status')}: {db.filename}
                        </h4>
                    </EuiTitle>
                    <NetworkLineChart
                        height={250}
                        legendWidth={175}
                        yAxisWidth={100}
                        data={props.data}
                        query={props.query}
                        setQuery={props.setQuery}
                        lines={[
                            {
                                key: `filemakerDatabaseStatus_${index}`,
                                label: t(
                                    'network:data_key_filemaker_db_status'
                                ),
                            },
                        ]}
                        xAxis="timestamp"
                        xAxisFormatter={(v) => formatTimestamp(v, props.query)}
                        xAxisDomain={xAxisDomain}
                        yAxisType="category"
                        yAxisDomain={['UNKNOWN', 'STOPPED', 'NORMAL']}
                        yAxisFormatter={(v) => {
                            return t(`network:data_value_${v}`)
                        }}
                    />
                </EuiFlexItem>
            ))}
        </EuiFlexGroup>
    )
}

export default FilemakerChart
